<template>
    <div class="container form-container p-4">
        <view-company :company="company" :show_update_button="false" :show_deactivation_button="false" />
    </div>
</template>

<script>
import ViewCompany from '@/components/views/Company.vue';

export default {
    components: {
        ViewCompany,
    },
    props: {
        company: Object,
    },
};
</script>
